import { render } from "./uploadFile.vue?vue&type=template&id=236b69b2"
import script from "./uploadFile.vue?vue&type=script&lang=js"
export * from "./uploadFile.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/c7p4yP7J/0/platform/zhenwu/iot-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/divform/uploadFile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "236b69b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('236b69b2', __exports__)) {
    console.log('reload')
    api.reload('236b69b2', __exports__)
  }
  
  module.hot.accept("./uploadFile.vue?vue&type=template&id=236b69b2", () => {
    console.log('re-render')
    api.rerender('236b69b2', render)
  })

}


export default __exports__